// extracted by mini-css-extract-plugin
export default {"overlay":"Ew-z","bodyOpen":"Fw-z","content":"Gw-z","header":"Hw-z","close":"Iw-z","closeNoHeading":"Jw-z"};